import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFileDownloadSignedUrl } from 'store/files/services/getFileDownloadSignedUrl.service';

async function requestFileEffect(attachment) {
  let imageUrl = null;
  try {
    imageUrl = await getFileDownloadSignedUrl(
      attachment.thumbnailFilePermission
    );
  } catch {}
  return imageUrl;
}

export const getImageUrlsThunk = createAsyncThunk(
  'chat/getImageUrls',
  async (_, { getState }) => {
    let { messages } = getState().chatSlice;
    const promises = messages
      .filter((message) => message.hasAttachment)
      .map(async (message) => {
        const attachmentPromises = (message.attachments || []).map(
          async (attachment) => {
            if (attachment.imageUrl) {
              return attachment;
            }
            const imageUrl = await requestFileEffect(attachment);
            return { ...attachment, imageUrl: imageUrl };
          }
        );
        const attachments = await Promise.all(attachmentPromises);
        return { id: message.id, attachments };
      });
    const resolvedPromises = await Promise.all(promises);

    return { messagesWithAttachments: resolvedPromises };
  }
);
